import { Handle, Position } from "@xyflow/react";
import React, { useState } from "react";
import { Button, Dropdown, DropdownButton } from "react-bootstrap";
import {
  addBranchToStep,
  updateAndThenInfo,
} from "../../services/CollectionsSvc";

const ViewFormBox = ({ data, onNewStep, totalSteps, onDelete, steps = [], hasVotes }) => {
  const { part, branchOption, branches, andThen } = data || [];
  const form = part?.form || [];
  const [selectedOption, setSelectedOption] = useState(andThen || null);

  const handleSelectOption = async (selectedStepId) => {
    if (selectedStepId === "end") {
      setSelectedOption(null);
      try {
        if (andThen) {
          await updateAndThenInfo(data.id, 0);
        }
      } catch (error) {
        console.error("Failed to save the selected option:", error);
      }
    } else {
      const nextStep = steps.find(
        (step) => step.id === parseInt(selectedStepId, 10)
      );
      if (nextStep) {
        const nextStepOrder = nextStep.order;
        setSelectedOption({ nextStepId: nextStep.id, nextStepOrder });

        try {
          if (andThen) {
            await updateAndThenInfo(data.id, nextStep.id);
          } else {
            await addBranchToStep(data.id, {
              branchOption: null,
              nextStepId: nextStep.id,
            });
          }
        } catch (error) {
          console.error("Failed to save the selected option:", error);
        }
      } else {
        console.error("Next step not found");
      }
    }
  };

  return (
    <div
      className={
        !branchOption && data?.stepIndex + 1 === totalSteps
          ? "last-step view-poll-box"
          : "view-poll-box"
      }
    >
      <Handle type="target" position={Position.Top} id="top-handle" />
      <Handle type="target" position={Position.Left} id="left-handle" />

      <div
        style={{
          marginRight: "0px",
          backgroundColor: "transparent",
          display: "flex",
          gap: "50px",
        }}
        key={form.id}
      >
        <div style={{ width: "350px" }}>
          {branchOption ? (
            <>
              <div className="user-option-selected-container">
                <div className="user-option-header">If user select</div>
                <span
                  className="remove-button"
                  onClick={() => onDelete(data.branchId, "branch")}
                >
                  Remove
                </span>
              </div>
              <div className="option-container">{branchOption}</div>
            </>
          ) : (
            <div className="step-number">
              <div className="d-flex justify-content-between px-1">
                <span className="customLabel fw-bold">Step {data.order}</span>
                <span
                  className="customLabel remove-button"
                  onClick={() => onDelete(data.id, "step")}
                >
                  Remove
                </span>
              </div>
            </div>
          )}
          <div className="form-box">
            <div className="form-box-title">{form.title}</div>
            <div className="form-box-description">{form.description}</div>
            {form.image && (
              <div className="form-box-image">
                <img
                  src={`https://cdn.sided.co/prod/sided/forms/${form.image}-small`}
                  alt="Form"
                />
              </div>
            )}

            {form?.formFields?.map((field) => (
              <div key={field.id} className="form-box-field">
                <input
                  disabled
                  className="form-box-input"
                  name={field.id}
                  type={
                    field.fieldType === "email"
                      ? "email"
                      : field.fieldType === "phone"
                        ? "tel"
                        : "text"
                  }
                  placeholder={field.placeholderText}
                  required={field.isRequired}
                />
              </div>
            ))}

            <button disabled className="form-box-submit blue-button">
              {form.buttonText || "Submit"}
            </button>

            <div className="form-box-terms">
              By clicking "Submit" you agree to Sided's{" "}
              <a
                className="text-button"
                href="https://sided.co/terms-of-service"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Service
              </a>{" "}
              and{" "}
              <a
                className="text-button"
                href="https://sided.co/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              .
            </div>
          </div>
          {branchOption &&
            branches?.length === 0 &&
            data?.stepIndex + 1 !== totalSteps && (
              <>
                <div className="user-option-selected-container option-container mt-2">
                  <div className="">And then</div>
                  <DropdownButton
                    id="and-then-dropdown"
                    size="md"
                    variant="outline-secondary"
                    title={
                      selectedOption
                        ? selectedOption.nextStepOrder <=
                          data.rootStep.stepOrder
                          ? `Return to Step ${selectedOption.nextStepOrder}`
                          : `Jump to Step ${selectedOption.nextStepOrder}`
                        : "End Sequence"
                    }
                    onSelect={handleSelectOption}
                    disabled={hasVotes}
                  >
                    {steps
                      .filter((step) => step.id !== data.id)
                      .map((step) => (
                        <Dropdown.Item
                          key={step.id}
                          eventKey={step.id.toString()}
                        >
                          Step {step.order}
                        </Dropdown.Item>
                      ))}
                    <Dropdown.Item eventKey="end">End Sequence</Dropdown.Item>
                  </DropdownButton>
                </div>
              </>
            )}
        </div>
        {!branchOption && data?.stepIndex + 1 === totalSteps && (
          <div>
            <div className="add-step-button-container">
              <div className="d-flex justify-content-between px-1">
                <span className="customLabel fw-bold">
                  Add Step {data.order + 1}
                </span>
              </div>
            </div>
            <div className="add-step-branch-group">
              <div className="d-flex justify-content-center border align-items-center add-step-container">
                <Button
                  onClick={() => onNewStep(data)}
                  className="add-step-button"
                >
                  +
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} id="bottom-handle" />
      <Handle type="source" position={Position.Right} id="right-handle" />
    </div>
  );
};

export default ViewFormBox;
